import { Trans } from "react-i18next";import * as DialogPrimitive from "@radix-ui/react-dialog";
import { AlertCircle } from "lucide-react";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogOverlay,
  DialogPortal,
  DialogTitle } from
"../../../components/ui/dialog";
import { ui } from "../../../components/ui";
import { cn } from "../../../lib/utils";

/**
 * Handles both delete outcomes from the PRD:
 * - unused shift: confirmation dialog before deleting
 * - shift assigned to any employee: delete blocked, inline message recommending Is Active = No
 */
export function DeleteShiftModal({ deletingShift, setDeletingShift, executeDeletion, deleting }) {
  const isBlocked = Boolean(deletingShift?.assignedEmployeeCount > 0);

  return (
    <Dialog
      open={Boolean(deletingShift)}
      onOpenChange={(open) => {
        if (!open && !deleting) setDeletingShift(null);
      }}>
      
      <DialogPortal>
        <DialogOverlay />
        <DialogPrimitive.Content
          className={cn(
            "fixed left-[50%] top-[50%] z-50 translate-x-[-50%] translate-y-[-50%]",
            "w-[95vw] sm:w-[440px] max-w-[440px] p-6 font-sans focus:outline-none",
            ui.card, // Synchronized container definition token
            "duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"
          )}>
          
          {isBlocked ?
          <>
              <DialogTitle className="text-[16px] font-bold text-foreground mb-3">
                <Trans i18nKey="validation.canTDelete" />{deletingShift?.shiftName}&quot;
              </DialogTitle>
              <div className="flex items-start gap-2 rounded-xl border border-[var(--status-warning-dot)]/25 bg-[var(--status-warning-bg)] px-3.5 py-2.5 text-left text-[13px] text-[var(--status-warning-fg)] mb-5">
                <AlertCircle className="h-4 w-4 shrink-0 mt-0.5 text-[var(--status-warning-dot)]" />
                <span>
                  <strong>{deletingShift?.assignedEmployeeCount} <Trans i18nKey="common.employees" /></strong> <Trans i18nKey="organizationShifts.areCurrentlyAssignedToThisShiftSet" /> 
                <strong><Trans i18nKey="organizationShifts.isActiveNo" /></strong> <Trans i18nKey="organizationShifts.insteadOfDeletingItToRetireTheShift" />
                
              </span>
              </div>
              <div className="flex justify-end gap-3">
                <Button
                type="button"
                onClick={() => setDeletingShift(null)}
                className="h-10 px-5 rounded-xl bg-[var(--color-primary)] text-white font-semibold text-sm hover:bg-[var(--color-accent)] transition shadow-sm">
                  <Trans i18nKey="formActions.close" />
                
              </Button>
              </div>
            </> :

          <>
              <DialogTitle className="text-[16px] font-bold text-foreground mb-3">
                <Trans i18nKey="formActions.delete" />{deletingShift?.shiftName}&quot;?
              </DialogTitle>
              <div className="bg-[var(--status-warning-bg)] border-l-4 border-[var(--status-warning-dot)] rounded-xl px-3.5 py-2.5 mb-5">
                <p className="m-0 text-[13px] text-[var(--status-warning-fg)] leading-relaxed font-medium">
                  <Trans i18nKey="validation.thisActionCannotBeUndoneTheShiftWill" />
                </p>
              </div>
              <div className="flex justify-end gap-3">
                <Button
                type="button"
                variant="outline"
                onClick={() => setDeletingShift(null)}
                disabled={deleting}
                className="h-10 px-4 rounded-xl border-[var(--color-primary)]/30 text-[var(--color-primary)] font-semibold text-sm hover:bg-[var(--color-workspace)]/40 bg-white transition">
                  <Trans i18nKey="formActions.cancel" />
                
              </Button>
                <Button
                type="button"
                onClick={executeDeletion}
                disabled={deleting}
                className="h-10 px-4 rounded-xl bg-[var(--color-error)] text-white font-semibold text-sm hover:bg-[var(--color-error)]/90 transition shadow-sm">
                
                  {deleting ? "Deleting..." : "Delete"}
                </Button>
              </div>
            </>
          }
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>);

}
